module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image7a.b256cc70.jpg";